export interface VerifyChildPostcodeTicket {
  postCode: string;
  ticketID: number;
  dateOfBirth: Date;
}
